import { createRoot } from "react-dom/client";
export class ReactRenderer {
    static render(className, renderFunction) {
        const callback = () => {
            Array.from(document.getElementsByClassName(className)).map((elem) => {
                const root = createRoot(elem);
                root.render(renderFunction(elem));
            });
        };
        if (document.readyState != "loading") {
            callback();
        }
        else {
            document.addEventListener("DOMContentLoaded", callback);
        }
    }
}
